module.exports = __webpack_public_path__ + "static/media/btn_more.aa6f4b86.svg";